import { render, staticRenderFns } from "./AnalyticsPay.vue?vue&type=template&id=c4abb47e&"
import script from "./AnalyticsPay.vue?vue&type=script&setup=true&lang=js&"
export * from "./AnalyticsPay.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports